<template>
  <LoadingOverlay v-if="isLoading" />
  <div v-else-if="!confirmedReservations.length && !pendingReservations.length">
    {{ emptyMessage }}
  </div>
  <div v-else>
    <b-container :fluid="true">
      <b-row>
        <b-col cols="9">
          <h1>Reservations</h1>
        </b-col>
      </b-row>
    </b-container>
    <hr>
    <!--    <CommunityCalendar-->
    <!--      style="margin-bottom:10px"-->
    <!--      :reservations="confirmedReservations.concat(pendingReservations)"-->
    <!--      :show-time="true"-->
    <!--    />-->
    <b-card>
      <b-card-body>
        <b-row>
          <h3><strong>Filters: </strong></h3>
        </b-row>
        <b-row>
          <b-form inline>
            <!--suppress XmlInvalidId -->
            <label
              for="searchByEmailInput"
              class="mr-3"
            >Search by requestor email:</label>
            <b-form-input
              id="searchByEmailInput"
              v-model="filters['user.email']"
              list="requestorEmailList"
              placeholder="User email"
            />
            <b-datalist id="requestorEmailList" />
          </b-form>
        </b-row>
        <b-row>
          <b-form-group label="Status: ">
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="filters.status"
              name="flavour-2"
            >
              <b-form-checkbox value="pending">
                Pending
              </b-form-checkbox>
              <b-form-checkbox value="confirmed">
                Confirmed
              </b-form-checkbox>
              <b-form-checkbox value="expired">
                expired
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-row>
        <b-row>
          <h3><strong>Actions:</strong></h3>
        </b-row>
        <b-row>
          <h4 v-if="!selectedReservations.length">
            Select one or more reservations to approve or decline
          </h4>
          <h4 v-else>
            {{ selectedMessage }}
          </h4>
        </b-row>
        <b-row
          v-if="selectedReservations.length"
          fluid
          class="flex-row"
        >
          <b-button
            size="sm"
            variant="outline-danger"
            :disabled="cancelPending"
            @click="cancelReservations"
          >
            <b-spinner v-if="cancelPending">
              Loading
            </b-spinner>
            <span v-else>Cancel Selected</span>
          </b-button>
          <span class="p-2" />
          <b-button
            size="sm"
            variant="outline-success"
            :disabled="acceptPending"
            @click="confirmReservations"
          >
            <b-spinner v-if="acceptPending">
              Loading
            </b-spinner>
            <span v-else>Accept Selected</span>
          </b-button>
        </b-row>
      </b-card-body>
    </b-card>
    <b-table
      ref="reservationsTable"
      striped
      hover
      :selectable="!actionPending"
      responsive="sm"
      sticky-header="400px"
      select-mode="multi"
      primary-key="id"
      :fields="fields"
      :items="filtered"
      class="align-middle"
      show-empty
      @row-selected="onRowSelected"
    >
      <template #head(selected)>
        <span>&nbsp;&nbsp;&nbsp;</span>
      </template>
      <template #emptyfiltered="scope">
        <h4>{{ scope.emptyFilteredText }}</h4>
      </template>

      <template #top-row="{fields: filterFields}">
        <td
          v-for="field in filterFields"
          :key="field.key"
        >
          <label>
            <input
              v-if="Object.keys(filters).includes(field.key) && field.key !== 'status'"
              v-model="filters[field.key]"
              :placeholder="field.label"
            >
          </label>
        </td>
      </template>

      <template #cell(selected)="{ rowSelected, index }">
        <template>
          <b-container
            :fluid="true"
            class="d-flex flex-fill center"
            style="height: 100%"
          >
            <b-form-checkbox
              :checked="rowSelected"
              @change="(checked)=>rowCheckboxClicked(checked,index)"
            />
            <span
              v-if="rowSelected"
              class="sr-only"
            >Selected</span>
            <span
              v-else
              class="sr-only"
            >Not selected</span>
          </b-container>
        </template>
      </template>
      <template #cell(show_details)="row">
        <b-button
          size="sm"
          class="mr-2"
          style="height: 50%"
          @click="row.toggleDetails"
        >
          {{ row.detailsShowing? 'Hide' : 'Show' }} Details
        </b-button>
      </template>
      <template #row-details="row">
        <b-card>
          <b-row class="mb-2">
            <b-col
              sm="3"
              class="text-sm-right"
            >
              Name:
            </b-col>
            <b-col>{{ row.item.user.name }}</b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col
              sm="3"
              class="text-sm-right"
            >
              Email:
            </b-col>
            <b-col>{{ row.item.user.email }}</b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col
              sm="3"
              class="text-sm-right"
            >
              Purpose:
            </b-col>
            <b-col>{{ row.item.purpose }}</b-col>
          </b-row>
        </b-card>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from 'axios';
import get from 'lodash/get';
import LoadingOverlay from '../../common/LoadingOverlay';
import { emitToast, VARIANT_TYPE } from '../../../util/Toast';
import { getStatusFromResponseIfExists, HTTP_STATUS_CODE } from '../../../util';
import CommunityCalendar from '../../common/CommunityCalendar/CommunityCalendar';
import { mapState } from 'vuex';

export default {
  name: 'Reservations',
  components: {
    CommunityCalendar,
    LoadingOverlay,
  },
  data: () => ({
    acceptPending:false,
    actionPending:false,
    cancelPending:false,
    confirmedReservations: '',
    emptyMessage: 'Loading Reservations...',
    fields: [
      { key: 'selected', label: '&nbsp;', sortable: false },
      { key: 'court.name', label: 'Court', sortable: true },
      { key: 'date', sortable: true },
      { key: 'start_time', sortable: false },
      { key: 'end_time', sortable: false },
      { key: 'status', sortable: false },
      'show_details',
    ],
    filters: {
      'court.name': '',
      date: '',
      end_time: '',
      start_time: '',
      status: ['pending', 'confirmed', 'expired'],
      'user.email': '',
    },
    isLoading: true,
    pendingReservations: '',
    requestorEmails:[],
    selectedReservations: [],
  }),
  computed: {
    ...mapState({
      organization: state => state.organization,
    }),
    filtered() {
      const filtered = (this.pendingReservations.concat(this.confirmedReservations)).filter(item => {
        return Object.keys(this.filters).every(key => {
          if (key === 'status' && this.filters.status.length) {
            return this.filters.status.includes(item.status);
          } else {
            return String(get(item, key).toLowerCase()).includes(this.filters[key].toLowerCase());
          }
        });
      });
      return filtered.length > 0 ? filtered : [];
    },

    selectedMessage() {
      const selectedReduce = this.selectedReservations.reduce((map, obj) => {
        map[obj.status] = map[obj.status]?[obj].concat(map[obj.status]):[obj];
        return map;
      }, {});


      const plural = this.selectedReservations.length > 1;
      if (this.selectedReservations.length <= 0)
        return 'Select one or more reservations to approve or decline';
      else
        return `There ${plural ? 'are' : 'is'} currently ${this.selectedReservations.length}
                        reservation${plural ? 's' : ''} selected  (
                        ${ (selectedReduce.pending? `${selectedReduce.pending.length} pending` : '') +
                          (
                            selectedReduce.confirmed? `
                              ${selectedReduce.pending?', '
                              : ''
                            }
                            ${selectedReduce.confirmed.length } confirmed` : ''
                          ) }
        )`;
    },
  },
  created() {
    this.getReservations();
  },
  methods: {

    async cancelReservations(){
      this.cancelPending = this.actionPending =  true;
      try {
        const { status, data: { cancelledReservations } } = await axios.post(
          `/api/${this.organization.slug}/manage/reservation/cancel`,
          { reservations: this.selectedReservations }
        );
        for (const reservation of cancelledReservations){
          const reservationToUpdate = this.pendingReservations.find(obj => obj.id === reservation.id);
          reservationToUpdate.status = reservation.status;
        }
        if (status === HTTP_STATUS_CODE.MULTI_STATUS){
          emitToast(this.$bvToast, VARIANT_TYPE.WARNING,
            'Some reservations may not have been updated. Please refresh and try again.'
          );
        } else {
          emitToast(this.$bvToast, VARIANT_TYPE.SUCCESS, 'Reservations cancelled!');
        }
        this.selectedReservations = [];
      } catch ({ response }) {
        if (getStatusFromResponseIfExists(response) === HTTP_STATUS_CODE.FORBIDDEN){
          emitToast(
            this.$bvToast,
            VARIANT_TYPE.WARNING,
            'You do not have the required access to manage reservtions'
          );
        }
      } finally {
        this.cancelPending = this.actionPending = false;
      }
    },

    async confirmReservations(){
      this.acceptPending = this.actionPending =  true;
      try {
        const { status, data: { completedReservations } } = await axios.post(
          `/api/${this.organization.slug}/manage/reservation/confirm`,
          { reservations: this.selectedReservations }
        );
        for (const reservation of completedReservations){
          const reservationToUpdate = this.pendingReservations.find(obj => obj.id === reservation.id);
          reservationToUpdate.status = reservation.status;
        }
        if (status === HTTP_STATUS_CODE.MULTI_STATUS){
          emitToast(this.$bvToast, VARIANT_TYPE.WARNING,
            'Some reservations may not have been updated. Please refresh and try again.'
          );
        } else {
          emitToast(this.$bvToast, VARIANT_TYPE.SUCCESS, 'Reservations confirmed!');
        }
        this.selectedReservations = [];
      } catch ({ response }) {
        if (getStatusFromResponseIfExists(response) === HTTP_STATUS_CODE.FORBIDDEN){
          emitToast(
            this.$bvToast,
            VARIANT_TYPE.WARNING,
            'You do not have the required access to manage reservtions'
          );
        }
      } finally {
        this.acceptPending = this.actionPending = false;
      }
    },

    async getReservations() {
      const response = await axios.get(`/api/${this.organization.slug}/manage/reservation`);
      const { confirmedReservations, pendingReservations } = response.data;
      this.pendingReservations = pendingReservations;
      this.confirmedReservations = confirmedReservations;
      this.emptyMessage = 'There are currently no reservations';
      this.isLoading = false;
    },

    onRowSelected(selected) {
      this.selectedReservations = selected;
    },

    rowCheckboxClicked(checked,index){
      if (checked) {
        this.$refs.reservationsTable.selectRow(index);
      } else {
        this.$refs.reservationsTable.unselectRow(index);
      }
    },
  },
};
</script>

<style scoped>
    table td {
        vertical-align: middle !important;
    }
</style>
